module.exports = __webpack_public_path__ + "static/media/features-surface-ad4.f43fa455.png";